import {
    destroyChatbot,
    initChatbot,
    readChatbotBootstrap,
    resetChatbot,
} from '../ai/chatbot';

declare const howspace: any;

howspace.widgets.coach = {
    initView: async (_widget: any) => {
        const widgetElement = _widget.get(0) as HTMLElement;
        const container = widgetElement.querySelector<HTMLElement>('.howspace-ai-chatbot');
        if (!container) {
            return;
        }

        const bootstrap = readChatbotBootstrap(container);
        if (!bootstrap) {
            return;
        }

        await initChatbot(widgetElement, container, bootstrap);

        _widget.find('.reset-thread').off('click.coachAi2').on('click.coachAi2', () => {
            resetChatbot(widgetElement, container).catch(error => {
                console.error('Coach widget: could not reset thread', error);
            });
        });
    },

    destroyView: (_widget: any) => {
        _widget.find('.reset-thread').off('click.coachAi2');
        destroyChatbot(_widget.get(0) as HTMLElement);
    },

    initEdit: () => {},
    destroyEdit: () => {},

    save: (widget: any, dataPayload: any) => {
        const sourceWidgets: Array<{type: string; id: string}> = [];
        widget.find('.howspace-item-picker .selected-items .item').each((index: number, element: HTMLElement) => {
            const widgetType = element.getAttribute('data-type') || '';
            const rawWidgetId = element.getAttribute('data-id') || '';
            sourceWidgets.push({type: widgetType, id: rawWidgetId.replace(`${widgetType}-`, '')});
        });
        dataPayload.sources = sourceWidgets;
        delete dataPayload.items;
        return dataPayload;
    },
};
